const personalDeskTop = () => import('@/views/main/desktop/personalDeskTop.vue')
export default {
  path: '/main/desktop/personalDeskTop',
  name: 'personalDeskTop',
  component: personalDeskTop,
  children: []
}
